module.exports = __webpack_public_path__ + "static/img/mdi-home.eb311e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/mdi-home.jpg
// module id = slzH
// module chunks = 1